import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TcApiError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-api-error';
import { TcHttpError } from '@tc-core/model/it/codegen/tbx/ext/errors/tc-http-error';
import { Journey } from '@tc-core/model/it/codegen/ui/framework/journey';
import { TC } from '@tc-core/util';
import { ConfigLoader } from '@tc-core/util/framework/config-loader.service';
import { EventManager } from '@tc-core/util/framework/event-manager.service';
import { UserJourneyManager } from '@tc-core/util/framework/user-journey-manager.service';
import { CommonHelper } from '@tc-core/util/helpers/common-helper.service';
import { DateFormatter } from '@tc-core/util/system';
import { SpinnerService } from '@tc-core/util/ui';
import { ChipInputComponent } from '@tc/chip-input';
import { ChipInputService } from '@tc/chip-input/chip-input.service';
import * as moment from 'moment';
import { Subscription } from 'rxjs';
import { TCO } from '../../constants';
import { NotificationSearchCriteria } from '../../models/criteria/notification-search-criteria';
import { NotificationService } from '../../services/backend-consumers/notifications/notification.service';
import { ChipHandlerService } from '../../services/helpers/chip-handler.service';
import { RootService } from '../../services/util/core-services/root.service';
import { ActionHandlerService } from '../../services/util/framework/action-handler-service.service';
import { DataKey, DataStoreService } from '../../services/util/framework/data-store.service';
import { DMCQueryParamsService } from '../../services/util/framework/dmc-query-params.service';

@Component({
    selector: 'tc-notification-queue-search-criteria',
    templateUrl: './notification-queue-search-criteria.component.html',
    providers: [
        ChipHandlerService,
        {provide: 'ChipHandlerService', useExisting: ChipHandlerService},
        ChipInputService
    ]
})
export class NotificationQueueSearchCriteriaComponent implements OnInit {
    @Input() isInsideForm: boolean = false;
    @Input() notificationSearchCriteria: NotificationSearchCriteria;
    @Input() searchCriteriaChipConfig: string;
    @Input() isSearchBarStyleNotAvailable: boolean = false;

    @Input() placeHolderText = 'Search Notifications';

    @Output() searchTrigger: EventEmitter<boolean> = new EventEmitter();
    @Output() searchCriteria: EventEmitter<any> = new EventEmitter();
    tPagination: any;

    journey: string = null;

    isChipsInit = false;
    availableChips: any[] = [];
    persistentChipsArr = [];
    persistentQParams: string[] = [];
    persistentQParamMap = new Map<string, string>();

    private relatedChipsObsv: Subscription = new Subscription();
    modifiedChip;

    isDataLoaded: boolean = true;
    isTriggerSearch: boolean = true;
    displayChipsArr = [];
    isFocus: boolean = false;
    isChipListDisplay = false;

    private routerChangeSubscription: Subscription;
    private selectedChipsObsv: Subscription = new Subscription();
    private selectedFieldsObsv: Subscription = new Subscription();
    private chipValueUpdateSub: Subscription = new Subscription();
    private criteriaUpdateSubscription: Subscription = new Subscription();
    private deletedChipObsv: Subscription = new Subscription();
    private userJourneyObserver: Subscription = new Subscription();
    private selectedChips = [];
    private focusSearchBarObserver: Subscription = new Subscription();
    private closePopUpObserver: Subscription = new Subscription();
    private errorsObserver: Subscription = new Subscription();
    private triggerSearchCriteriaObserver: Subscription = new Subscription();
    private searchResultObserver: Subscription = new Subscription();
    private relatedChipsProcessObsv: Subscription = new Subscription();

    private chipInputService;
    @ViewChild('notification_search_chip_input') notificationSearchChipInput: ChipInputComponent;
    private chipHandlerSubject: Subscription = new Subscription();

    constructor(
        private activatedRoute: ActivatedRoute,
        private configLoader: ConfigLoader,
        private userJourneyManager: UserJourneyManager,
        private dataStoreService: DataStoreService,
        private actionHandlerService: ActionHandlerService,
        private em: EventManager,
        private notificationService: NotificationService,
        private chipHandler: ChipHandlerService,
        private queryParamService: DMCQueryParamsService,
        private commonHelper: CommonHelper,
        private spinnerService: SpinnerService,
        private dateFormatter: DateFormatter,
        private rootService: RootService
    ) { }

    ngOnInit() {
        this.chipInputService = this.notificationSearchChipInput.criteriaInputService;

        // clear data store
        this.dataStoreService.set(DataKey.notificationSearchCriteria, null, true);

        this.handleQuickActions();

        this.userJourneyObserver = this.userJourneyManager.journey.subscribe((journey: Journey) => {
            if (journey && JSON.stringify(journey) !== JSON.stringify({})) {
                this.journey = journey.id;
            }
        });

    // resetting the view
    this.routerChangeSubscription = this.userJourneyManager.routeChanges.subscribe(e => {
      if (e) {
        this.chipInputService.fullReset(); // fully reset chips
        this.chipHandler.chipsArr = []; // reset chips array loaded from config
        // check journey begins from quick book
        if (!this.isInsideForm) {
          this.getQueryParams();
          this.initSearchCriteriaChips();
        }

        console.log('displayChipsArr', this.displayChipsArr);
        this.resetQueryParams();
      }
    });

        if (!this.isInsideForm) {
            if (!this.isChipsInit) {
                this.initSearchCriteriaChips(); // load everything from start
            }
        }
        this.getSearchObserver();
        this.errorObserver();
        this.selectedChipsUpdate();
        this.handleInterRelatedChips();
        this.notifyChipDelete();
        this.shortCutObserver();
    }

    getQueryParams() {
        let queryParams: string[] = [];
        queryParams = this.queryParamService.getQueryParamsArray(new NotificationSearchCriteria());

        this.notificationSearchCriteria = this.rootService.loadDataFromLocalStorage(queryParams, new NotificationSearchCriteria(),
            TCO.AppData.NOTIFICATION_SEARCH_CRITERIA
        );

        if (this.notificationSearchCriteria) {
            if (!this.notificationSearchCriteria.startDate) {
                this.notificationSearchCriteria.startDate = new Date().toISOString().split('T')[0];
            }
            if (!this.notificationSearchCriteria.endDate) {
                this.notificationSearchCriteria.endDate
                    = new Date(+new Date(this.notificationSearchCriteria.startDate) + 172800000)
                    .toISOString().split('T')[0];
            }
            if (!this.notificationSearchCriteria.type) {
                this.notificationSearchCriteria.type = 'ANY';
            }
        }


        // get persisting query params
        if (this.notificationSearchCriteria) {
            this.persistentQParams = [];
            this.persistentQParams = this.queryParamService.getNotNullQueryParamsArray(this.notificationSearchCriteria);
        }
    }

    private shortCutObserver() {
        this.focusSearchBarObserver = this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'FOCUS_SEARCH_BAR')
                                          .subscribe(e => {
                                              this.isFocus = true;
                                          });
        this.closePopUpObserver = this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'CLOSE_POPUPS')
                                      .subscribe(e => {
                                          this.isFocus = false;
                                      });
    }

    public onFocus(event: boolean) {
        this.isFocus = event;
    }

    initSearchCriteriaChips() {
        this.isChipsInit = true;

        // read chip config
        let criteriaChipConfigs = null;
        if (!this.isInsideForm) {
            const chipConfigs = this.configLoader.configurations.get(TCO.CONF.CONF_NOTIFICATION_QUEUE_CHIP);
            criteriaChipConfigs = this.commonHelper.recreateJsonObject(chipConfigs);
        } else {
            const chipConfigs = this.configLoader.configurations.get(this.searchCriteriaChipConfig);
            criteriaChipConfigs = this.commonHelper.recreateJsonObject(chipConfigs);
        }
        if (criteriaChipConfigs && criteriaChipConfigs.chips) {
            criteriaChipConfigs.chips.forEach(chip => {
                chip = this.chipHandler.preProcessChips(chip, criteriaChipConfigs.permissionKeys.keys);
            });
        }

        this.chipHandler.chipsSubject.subscribe(data => {
            if (data && JSON.stringify(data) !== JSON.stringify([]) ) {
                this.availableChips = data; // new json object here;
                this.chipHandler.chipsSubject.next(null);

                if (this.chipHandlerSubject) {
                    this.chipHandlerSubject.unsubscribe();
                }

                // set values to display chips
                this.displayChipsArr = [];
                this.displayChipsArr = this.availableChips;

                this.dataStoreService.set(DataKey.chips, this.availableChips, true);

                this.chipInputService.init(this.notificationSearchCriteria, this.availableChips, false, true);
                this.isChipsInit = true;

                // implement chip persistence
                if (this.persistentQParams && this.persistentQParams.length > 0) {
                    // create a queryParamMap
                    for (const qParam of this.persistentQParams) {
                        const qParamValue = this.notificationSearchCriteria[qParam];
                        this.persistentQParamMap.set(qParam, qParamValue);
                    }
                    this.persistentChipsArr = [];
                    // fill persistent chips
                    this.availableChips.forEach(chip => {
                        const persistChip = Object.assign({}, chip);
                        persistChip.optionParams.data = [];
                        let isPersist = false;
                        if (chip.dataParams && chip.dataParams.length > 0) {
                            chip.dataParams.forEach(dataParam => {
                                if (this.persistentQParamMap.has(dataParam.paramValue)) {
                                    isPersist = true;
                                    const dataObj = {
                                        key: dataParam.paramValue,
                                        value: this.persistentQParamMap.get(dataParam.paramValue)
                                    };
                                    persistChip.optionParams.data.push(dataObj);
                                }
                            });
                        }
                        // push persist chips to an array
                        if (isPersist) {
                            this.persistentChipsArr.push(persistChip);
                        }
                    });

                    // persist chips
                    if (this.persistentChipsArr && this.persistentChipsArr.length > 0) {
                        const uniqueChipList = this.persistentChipsArr.filter((e, i) => {
                            return this.persistentChipsArr.findIndex((x) => {
                                if (x.criteriaType === 'CALENDAR' && typeof x.optionParams.data[0].value !==
                                    'string') {
                                    x.optionParams.data[0].value = moment(x.optionParams.data[0].value)
                                        .format('YYYY-MM-DD');
                                }
                                return x.criteriaId === e.criteriaId;
                            }) === i;
                        });

                        this.chipInputService.persistChips(uniqueChipList);

                        // trigger search when chips persisting
                        this.isDataLoaded = false;
                        this.onNotificationSearch(this.notificationSearchCriteria);
                    }
                }

                // this.isTriggerSearch = false;
                // this.onNotificationSearch(this.notificationSearchCriteria);

                this.chipInputService.criteriaUpdate.subscribe((updatedCriteriaData) => {
                    this.notificationSearchCriteria = updatedCriteriaData;
                });
            }
        });
    }

    public onNotificationSearch(event) {
        this.isDataLoaded = false;
        this.notificationSearchCriteria = event;

        this.userJourneyManager.canProceed.next(false);

        if (JSON.stringify(this.notificationSearchCriteria) !== JSON.stringify({})) {
            this.notificationSearchCriteria.dmc = true;
            this.dataStoreService.set(DataKey.notificationSearchCriteria, this.notificationSearchCriteria, true);

            this.dataStoreService.set(DataKey.notificationSearchResultsFromService, null, true);

            // set criteria parameters to url
            let queryParams: string[] = [];
            queryParams = this.queryParamService.getQueryParamsArray(this.notificationSearchCriteria);
            this.rootService.setDataToLocalStorage(TCO.AppData.NOTIFICATION_SEARCH_CRITERIA, this.notificationSearchCriteria, true,
                queryParams, true
            );

            // remove grid sorting and filtering
            // this.notificationSearchCriteria.gridFiltering = undefined;
            // this.notificationSearchCriteria.gridSorting = "[{'colId':'modifiedDate','sort':'asc'}]";

            // search data
            // commented search will trigger by data grid
            // this.notificationService.searchNotifications(this.notificationSearchCriteria);

            this.isTriggerSearch = false;
            this.isDataLoaded = false;
            this.searchTrigger.emit(true);

        } else {
            setTimeout(() => {
                this.isDataLoaded = true;
                this.isTriggerSearch = true;
            }, 0);
        }
    }

    getUpdatedFieldsDataObject(chip, criteria: NotificationSearchCriteria) {
        const dataObjArr = [];

        if (chip && chip.dataParams && chip.dataParams.length > 0) {
            chip.dataParams.forEach(dataParam => {
                const dataObj = {
                    key: '',
                    value: ''
                };
                dataObj.key = dataParam.paramValue;
                dataObj.value = criteria[dataParam.paramValue];

                dataObjArr.push(dataObj);
            });
        }

        return dataObjArr;
    }

    private getSearchObserver() {
        this.searchResultObserver = this.dataStoreService.get(DataKey.notificationSearchResultsFromService)
                                        .subscribe((data) => {
                                            if (this.commonHelper.dataValidity(data)) {
                                                this.isDataLoaded = true;
                                                this.isTriggerSearch = false;
                                            } else if (this.commonHelper.isEmptyData(data)) {
                                                this.isDataLoaded = true;
                                            } else if (data instanceof TcApiError) {
                                                this.isDataLoaded = true;
                                            } else if (data instanceof TcHttpError) {
                                                this.isDataLoaded = true;
                                            }
                                        }, (error: any) => {
                                            console.log(error);
                                        });

    }

    private errorObserver() {
        this.errorsObserver = this.dataStoreService.get(DataKey.error)
                                  .subscribe((data) => {
                                      if (data && JSON.stringify(data) !== JSON.stringify({})) {
                                          setTimeout(() => {
                                              this.isDataLoaded = true;
                                          }, 0);
                                          this.dataStoreService.set(DataKey.error, null);
                                      }
                                  });
    }

    private resetQueryParams() {
        let notificationsQueryParams: string[] = [];
        notificationsQueryParams = this.queryParamService.getQueryParamsArray(new NotificationSearchCriteria());

        const notificationSearchCriteria: NotificationSearchCriteria = this.rootService.loadDataFromLocalStorage(notificationsQueryParams,
            new NotificationSearchCriteria(), TCO.AppData.NOTIFICATION_SEARCH_CRITERIA
        );

        // set criteria parameters to url
        let queryParams: string[] = [];
        queryParams = this.queryParamService.getQueryParamsArray(notificationSearchCriteria);

        this.rootService.setDataToLocalStorage(TCO.AppData.NOTIFICATION_SEARCH_CRITERIA, this.notificationSearchCriteria,
            true, queryParams, true
        );
    }

    public onCancel($event) {
        console.log('cancelled');
    }

    public onChipListDisplay(event) {
        this.dataStoreService.set(DataKey.chipListDisplay, null, true);
        this.isChipListDisplay = event;
        this.dataStoreService.set(DataKey.chipListDisplay, this.isChipListDisplay, true);

    }

    handleQuickActions() {
        this.triggerSearchCriteriaObserver = this.em.addEvent(TC.CONF.CONF_EVENT_MANAGER, 'TRIGGER_SEARCH_CRITERIA')
                                                 .subscribe((e) => {
                                                     this.triggerSearch(e.data);
                                                 });
    }

    triggerSearch(data: string) {
        this.notificationSearchCriteria = new NotificationSearchCriteria();
        // todo criteria

        this.actionHandlerService.fillCriteriaByActionData(data, this.notificationSearchCriteria);
        const requiredChips = this.chipHandler.getChipsFromCriteria(
            this.notificationSearchCriteria,
            TCO.CONF.CONF_NOTIFICATION_QUEUE_CHIP,
            true
        );
        this.chipInputService.hardReset();
        this.chipInputService.persistChips(requiredChips, true);
        this.onNotificationSearch(this.notificationSearchCriteria);
    }

    private handleInterRelatedChips() {
        this.relatedChipsObsv = this.chipInputService.relatedChipsSubject.subscribe(
            (data) => {
                let toggleChips = [];
                if (data && data.chip && JSON.stringify(data) !== JSON.stringify({})) {
                    this.modifiedChip = data.chip;
                    // TODO: refine chip input service: inter related chips
                    if (data.chip.type === 'CALENDAR') {
                        // startDate & returnDate validate
                        if (data.chip.id === 'START_DATE') {
                            const startDate = data.date;
                            const nights = 2;
                            const currentEndDate = this.checkDependentForCalculateRelatedDate(data.chip);
                            if (currentEndDate) {
                                this.setMinDateForRelatedDateChips(data.chip, data.date);

                                if (this.dateFormatter.isAfter(startDate, currentEndDate)) {
                                    this.chipHandler.handleInterRelatedChips(
                                        data.chip,
                                        this.dateFormatter.addDaysToDate(startDate, nights)
                                    );
                                } else {
                                    this.chipHandler.handleInterRelatedChips(data.chip, currentEndDate);
                                }
                            }
                        }
                    } else {
                        this.chipHandler.handleInterRelatedChips(data.chip, data.options.value[0]);
                    }

                    if (data.chip.optionParams.toggleChips && data.chip.optionParams.toggleChips.length > 0) {
                        toggleChips = data.chip.optionParams.toggleChips;
                        if (toggleChips && data.options && data.options.value[0].value) {
                            this.chipInputService.selectedChipsBasedOnStateChange(toggleChips);
                        } else {
                            this.chipInputService.deleteChipsBasedOnStateChange(toggleChips);
                        }
                    }
                }
            }
        );

        this.relatedChipsProcessObsv = this.chipHandler.relatedChipsProcessSubject.subscribe((result) => {
            if (result && JSON.stringify(result) !== JSON.stringify([]) &&
                this.modifiedChip.optionParams.relatedChips &&
                this.modifiedChip.optionParams.relatedChips.length > 0 &&
                result.length === this.modifiedChip.optionParams.relatedChips.length) {

                // if chip date is passed date it will be reset for today
                result.forEach(chip => {
                        if (chip.dataParam === 'DATE' && chip.criteriaId === 'START_DATE') {
                            chip.options = this.dateFormatter.dateFromString(chip.options) > this.dateFormatter.getToday()
                                ? chip.options
                                : this.dateFormatter.dateAsString(this.dateFormatter.getToday());
                        }
                        if (chip.dataParam === 'DATE' && chip.criteriaId === 'END_DATE') {
                            chip.options = this.dateFormatter.dateFromString(chip.options) > this.dateFormatter.getToday()
                                ? chip.options
                                : this.dateFormatter.dateAsString(this.dateFormatter.getToday());
                        }
                    }
                );

                // pass related chips to chip input service
                this.chipInputService.handleInterRelatedChips(result);
            }
        });
    }

    private setMinDateForRelatedDateChips(chip: any, date: string) {
        if (date && chip && chip.optionParams && chip.optionParams.relatedChips) {
            const minDate = this.dateFormatter.dateFromString(date);
            chip.optionParams.relatedChips.forEach(relateChip => {
                if (relateChip.criteriaType === 'CALENDAR') {
                    relateChip.data = [{key: 'minDate', value: minDate}];
                }
            });
        }
    }

    private checkDependentForCalculateRelatedDate(chip: any) {
        let dateParam;
        if (chip.optionParams && chip.optionParams.relatedChips) {
            const dependent = chip.optionParams.behaviouralData.find(
                behData => behData.key === 'DATE_RELATED_DEPENDENT');
            if (dependent) {
                dateParam = this.getValueOfDependentParameter(dependent.value);
            }
        }
        return dateParam;
    }

    private getValueOfDependentParameter(dependent: any): any {
        if (this.chipInputService && this.chipInputService.criteria &&
            this.chipInputService.criteria[dependent.paramValue]) {
            return this.chipInputService.criteria[dependent.paramValue];
        }
        return '';
    }

    private selectedChipsUpdate() {
        this.criteriaUpdateSubscription = this.chipInputService.selectedChipsSubject
                                              .subscribe(selectedChips => {
                                                  this.selectedChips = selectedChips;

                                                  if (selectedChips && JSON.stringify(selectedChips) !==
                                                      JSON.stringify([])) {
                                                      // toggle chips when selecting BRANCH_OF_CLIENT_ID chip
                                                      for (const selectedChip of this.selectedChips) {
                                                          if (selectedChip.chip.id === 'BRANCH_OF_CLIENT_ID' &&
                                                              selectedChip.chip.optionParams.toggleChips &&
                                                              selectedChip.chip.optionParams.toggleChips.length > 0) {
                                                              this.deleteToggleChips(selectedChip.chip.optionParams.toggleChips);
                                                              this.disableChips(selectedChip.chip.optionParams.toggleChips);
                                                              break;
                                                          }
                                                      }
                                                  }
                                              });
    }

    private notifyChipDelete() {
        this.deletedChipObsv = this.chipInputService.deletedChipsSubject
                                   .subscribe(deletedChip => {
                                       if (JSON.stringify(deletedChip) !== JSON.stringify({}) && deletedChip !== null &&
                                           deletedChip !==
                                           undefined) {
                                           if (deletedChip.id === 'CLIENT_TYPE') {
                                               const deleteChips = this.selectedChips.map(chip => chip.chip);
                                               this.deleteSelectedChips(deleteChips);
                                               this.enableChips(this.availableChips);
                                           } else if (deletedChip.id === 'BRANCH_OF_CLIENT_ID') {
                                               if (deletedChip.optionParams.toggleChips &&
                                                   deletedChip.optionParams.toggleChips.length > 0) {
                                                   this.enableChips(deletedChip.optionParams.toggleChips);
                                               }
                                           }
                                       }
                                   });
    }

    private deleteToggleChips(toggleChips: any[]) {
        const deleteChips = [];
        toggleChips.forEach(toggleChip => {
            for (const selectedChip of this.selectedChips) {
                if (selectedChip.chip.id === toggleChip.criteriaId) {
                    deleteChips.push(selectedChip.chip);
                    break;
                }
            }
        });
        this.deleteSelectedChips(deleteChips);
    }

    private deleteSelectedChips(deleteChips: any[]) {
        deleteChips.forEach(chip => {
            this.chipInputService.deleteChip(chip, true);
        });
    }

    private enableChips(enableChips: any[]) {
        enableChips.forEach(enableChip => {
            this.chipInputService.modifyChipsStatus(enableChip, false);
        });
    }

    private disableChips(disableChips: any[]) {
        disableChips.forEach(disableChip => {
            this.chipInputService.modifyChipsStatus(disableChip, true);
        });
    }

    ngOnDestroy() {
        this.routerChangeSubscription.unsubscribe();
        this.userJourneyManager.routeChanges.next(false);

        if (this.selectedChipsObsv) {
            this.selectedChipsObsv.unsubscribe();
        }
        if (this.selectedFieldsObsv) {
            this.selectedFieldsObsv.unsubscribe();
        }
        if (this.chipValueUpdateSub) {
            this.chipValueUpdateSub.unsubscribe();
        }
        if (this.criteriaUpdateSubscription) {
            this.criteriaUpdateSubscription.unsubscribe();
        }
        if (this.deletedChipObsv) {
            this.deletedChipObsv.unsubscribe();
        }
        if (this.searchResultObserver) {
            this.searchResultObserver.unsubscribe();
        }
        if (this.errorsObserver) {
            this.errorsObserver.unsubscribe();
        }
        if (this.userJourneyObserver) {
            this.userJourneyObserver.unsubscribe();
        }
        if (this.focusSearchBarObserver) {
            this.focusSearchBarObserver.unsubscribe();
        }
        if (this.closePopUpObserver) {
            this.closePopUpObserver.unsubscribe();
        }
        if (this.triggerSearchCriteriaObserver) {
            this.triggerSearchCriteriaObserver.unsubscribe();
        }

        this.em.removeEvents([
            'TRIGGER_SEARCH_CRITERIA'
        ]);
    }

}
